export default [
  {
    id: 1,
    Codice: '25_3DROUND',
    Indoor: true,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 2,
    Codice: '25_3DROUND_10',
    Indoor: true,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 3,
    Codice: '25_TROPHY',
    Indoor: true,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 4,
    Codice: '25_TROPHY_10',
    Indoor: true,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 5,
    Codice: '40_3DROUND',
    Indoor: true,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 6,
    Codice: '40_3DROUND_10',
    Indoor: true,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 130,
    Codice: '40_FREE_SHOT',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 7,
    Codice: '40_ROUND',
    Indoor: false,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 8,
    Codice: '40_ROUND_10',
    Indoor: false,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 9,
    Codice: '40_TROPHY',
    Indoor: true,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 10,
    Codice: '40_TROPHY_10',
    Indoor: true,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 11,
    Codice: '44_FUSION',
    Indoor: false,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 12,
    Codice: '44_FUSION_10',
    Indoor: false,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 13,
    Codice: '60_TRACK',
    Indoor: false,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 14,
    Codice: '60_TRACK_10',
    Indoor: false,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 15,
    Codice: '60_TARGET',
    Indoor: false,
    NumeroPosti: 120,
    isAttivo: true,
  },
  {
    id: 16,
    Codice: '60_TARGET_10',
    Indoor: false,
    NumeroPosti: 60,
    isAttivo: true,
  },
  {
    id: 96,
    Codice: 'CI_OUTDOOR',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: false,
  },
  {
    id: 97,
    Codice: 'CI_INDOOR',
    Indoor: true,
    NumeroPosti: 0,
    isAttivo: false,
  },
  {
    id: 98,
    Codice: 'CI_REGIONI',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: false,
  },
  {
    id: 99,
    Codice: 'ST_HISTORY_EU',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 100,
    Codice: 'RO_ROVING',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 101,
    Codice: '99_ALTRO_INDOOR',
    Indoor: true,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 102,
    Codice: '99_ALTRO',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 103,
    Codice: 'IBO_OUTDOOR',
    Indoor: false,
    NumeroPosti: 0,
    isAttivo: true,
  },
  {
    id: 103,
    Codice: 'IBO_INDOOR',
    Indoor: true,
    NumeroPosti: 0,
    isAttivo: true,
  },
];
